import { Box } from 'components/Box';
import { Icon } from 'components/Icon/Icon';
import { ListingType } from 'types/ListingType';
import { showModal } from 'zustand-stores/modalStore';

import { StyledDropdownItem } from './ListingActionsDropdown.styled';

type Props = {
  closeMenu: () => void;
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  mobileOnly?: boolean;
  orgId?: string;
};

export function ShareMenuItem({
  closeMenu,
  listingId,
  listingType,
  listingUrl,
  mobileOnly,
  orgId,
}: Props) {
  if (listingType !== 'ORG' && !orgId) {
    return null;
  }

  return (
    <StyledDropdownItem
      $mobileOnly={mobileOnly}
      data-qa-id="share-button"
      onClick={(e) => {
        e.preventDefault();

        closeMenu();

        showModal('SHARE_LISTING', {
          listingId,
          listingType,
          listingUrl,
        });
      }}
    >
      <Box mr="10px">
        <Icon name="share" size={16} />
      </Box>
      {getText('Share')}
    </StyledDropdownItem>
  );
}
